import { SET_OPEN_BANKING_SECURE_KEY } from "../const";


export interface IOpenBankingState {
  RSAKey:string | undefined
}

const initalState = {
  RSAKey:undefined
};
export function openBankingReducer(state: IOpenBankingState = initalState, action: any) {
    switch (action.type) {
        case SET_OPEN_BANKING_SECURE_KEY:
            return {
                ...state,
                RSAKey: action.payload
            };
        default:
            return state;
    }
}